var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['m-edition-asset-content-node',
  _vm.isTask ? 'm-edition-asset-content-node-task' : '']},_vm._l((_vm.texto.blocks),function(block,index){return _c(`MoleculeContentNodeBlock${block.type}`,{key:index,tag:"Block",attrs:{"block":block}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }